import React, { Component } from "react";
import ReactDOM from "react-dom";
import { withRouter } from "react-router-dom";

import Api from "../../../lib/componentApi";
import getAppErrors from "../../../lib/appErrors";
import mixpanel from "../../../lib/mixPanel";

import Loading from "../../Common/Loading";
import PastListItem from "./PastListItem";
import RecentListItem from "./RecentListItem";
import CommonHeader from "../../Common/Header";

import Detail from "./Detail";
import Rate from "./Rate";
import Tip from "./Tip";

import AppErrors from "../../Common/AppErrors";
import getRestaurantsLink from "../../../lib/getRestaurantsLink";
import OrdersNotFound from "./components/List/OrdersNotFound";
import getAppStrings from "../../../lib/appStrings";

class List extends Component {
  constructor(props) {
    super(props);
    const { hash } = props.location || "";
    this.state = {
      orderSection: !!hash,
      rateOrder: false,
      orderId: (!!hash && hash.replace("#", "")) || "",
      resultSection: false,
      tipOrder: false,
      errorMessage: null,
      errorTitle: null,
      driver: null
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { hash } = nextProps.location || "";
    if (
      !hash &&
      !nextProps.orderDetail &&
      nextProps.orderDetail !== prevState.orderSection
    ) {
      return {
        orderSection: nextProps.orderSection
      };
    }

    return null;
  }
  handleRateOrder = (orderId, disabled) => {
    if (!disabled) {
      var body = document.body;
      body.classList.add("body-overflow");
      mixpanel.track("Rate Order on Orders Tab Click");
      this.setState({ rateOrder: true, orderId });
    }
  };
  handleOpenOrderSection = orderId => {
    mixpanel.track("Order Detail Screen", { "Order ID": orderId });
    this.setState({ orderSection: true, rateOrder: false, orderId });
  };
  handleClickClose = status => {
    this.setState(
      {
        [status]: false,
        orderId: ""
      },
      () => {
        if (
          status === "errorMessage" ||
          status === "rateOrder" ||
          status === "tipOrder"
        ) {
          this.setState({
            errorTitle: null
          });
          var body = document.body;
          body.classList.remove("body-overflow");
        }
        if (status === "orderSection") {
          const { history, location } = this.props;
          const { pathname, search } = location;
          history.push({
            pathname,
            search
          });
        }
      }
    );
  };
  handleSubmitRate = rateData => {
    Api.post("/api/order/rate", rateData, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        const errorMessage = getAppErrors(response.code);
        this.setState({
          errorMessage:
            (errorMessage && errorMessage.message) || response.message
        });
      } else {
        if (response.status) {
          mixpanel.track("Rate Order", {
            "Food Quality": rateData.answer1,
            "Restaurant Service": rateData.answer2,
            "Delivery Time": rateData.answer3,
            Comment: !!rateData.comment
          });
          this.setState({
            rateOrder: false,
            resultSection: true,
            orderId: ""
          });
          location.reload();
        }
      }
    });
  };
  handleReOrder = orderUid => {
    var body = document.body;
    Api.post("/api/order/reorder", { orderUid }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        const errorMessage = getAppErrors(response.code);
        body.classList.add("body-overflow");
        this.setState({
          errorMessage:
            (errorMessage && errorMessage.message) || response.message
        });
      } else {
        if (response.status) {
          mixpanel.track("Checkout Screen", { _source: "Orders" });
          window.location.href = "/checkout";
        } else {
          this.setState({
            errorMessage: "The restaurant is not available for the order."
          });
        }
      }
    });
  };
  renderResultSection = () => {
    return (
      <React.Fragment>
        {/* Header */}
        <div className="head-general with-back">
          <a
            href="javascript: void(0)"
            className="back"
            onClick={() => this.handleClickClose("resultSection")}
          >
            <img src="/png/chevron-left.png" />
          </a>
          <h4>Thank you!</h4>
          <a href="javascript: void(0)" className="close" />
        </div>
        {/* Header */}
        <div>
          <div className="white-bg mt-10px alert-box">
            Thank you for your comment.
          </div>
          <div className="use-buttons">
            <button
              className="btn btn-blue"
              onClick={() => this.handleClickClose("resultSection")}
            >
              Ok
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  };
  handleTipOrder = (orderId, deliveryDriver) => {
    mixpanel.track("Tip on Order Rate Click");
    var body = document.body;
    body.classList.add("body-overflow");
    this.setState({
      tipOrder: true,
      orderId,
      driver: deliveryDriver
    });
  };
  handleSubmitTip = (orderUid, amount, defaultPayment) => {
    const paymentSourceType = 1;
    const paymentSourceToken = defaultPayment.uid;
    Api.post(
      "/api/order/tip",
      { orderUid, amount, paymentSourceType, paymentSourceToken },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          const errorMessage = getAppErrors(response.code);
          this.setState({
            errorMessage:
              (errorMessage && errorMessage.message) || response.message
          });
        } else {
          this.handleClickClose("tipOrder");
        }
      }
    );
  };

  restaurantsLink = () => {
    let href = getRestaurantsLink();
    if (href) {
      return href;
    }
  };
  onClickDeliveredBy = (event, restaurantName) => {
    event.preventDefault();
    event.stopPropagation();
    const strings = getAppStrings(6022);
    if (strings) {
      const deliveredByMessage = strings.message;
      const deliveredByTitle = strings.title.replace("[:par1]", restaurantName);
      var body = document.body;
      body.classList.add("body-overflow");
      this.setState({
        errorMessage: deliveredByMessage,
        errorTitle: deliveredByTitle
      });
    }
  };
  render() {
    const {
      orderSection,
      rateOrder,
      orderId,
      resultSection,
      tipOrder,
      errorTitle,
      errorMessage,
      driver
    } = this.state;
    const { pastOrders, recentOrders, loading } = this.props;
    let documentContent = null;
    //eslint-disable-next-line
    if (__isBrowser__) {
      documentContent = document.getElementById("content");
    }
    const restaurantsLink = this.restaurantsLink();

    if (loading) {
      return <Loading />;
    }
    if (orderId && rateOrder) {
      return ReactDOM.createPortal(
        <Rate
          orderUid={orderId}
          onClickClose={this.handleClickClose}
          onSubmitRate={this.handleSubmitRate}
        />,
        documentContent || document.body
      )
    }
    if (orderId) {
      if (orderSection) {
        return (
          <>
            {errorMessage &&
              ReactDOM.createPortal(
                <AppErrors
                  title={errorTitle || ""}
                  message={errorMessage}
                  onClickClose={() => this.handleClickClose("errorMessage")}
                />,
                documentContent || document.body
              )}
            {tipOrder &&
              ReactDOM.createPortal(
                <Tip
                  orderUid={orderId}
                  onClickClose={this.handleClickClose}
                  onSubmitTip={this.handleSubmitTip}
                  driver={driver}
                />,
                documentContent || document.body
              )}
            <Detail
              onClickDeliveredBy={this.onClickDeliveredBy}
              orderUid={orderId}
              onClickClose={this.handleClickClose}
              handleRateOrder={this.handleRateOrder}
              handleReOrder={this.handleReOrder}
              handleTipOrder={this.handleTipOrder}
            />
          </>
        );
      }
    }
    if (resultSection) {
      this.renderResultSection();
    }
    const { pathname, search } = this.props.location;
    if (recentOrders.length || pastOrders.length) {
      return (
        <div>
          {errorMessage &&
            ReactDOM.createPortal(
              <AppErrors
                title={errorTitle || ""}
                message={errorMessage}
                onClickClose={() => this.handleClickClose("errorMessage")}
              />,
              documentContent || document.body
            )}
          <CommonHeader active="orders" />
          {(recentOrders &&
            recentOrders.length &&
            recentOrders
              .sort(
                (first, next) =>
                  new Date(next.orderDate) - new Date(first.orderDate)
              )
              .map(order => (
                <RecentListItem
                  onClickDeliveredBy={this.onClickDeliveredBy}
                  key={order.uid}
                  pathname={pathname}
                  search={search}
                  order={order}
                  handleOpenOrderSection={this.handleOpenOrderSection}
                  handleRateOrder={this.handleRateOrder}
                  handleReOrder={this.handleReOrder}
                />
              ))) || <noscript />}
          <div className="container container-profile-order">
            {(pastOrders && pastOrders.length && (
              <div className="white-bg order-box mt-10px">
                <h5>Past</h5>
                <div className="items">
                  {pastOrders
                    .sort(
                      (first, next) =>
                        new Date(next.orderDate) - new Date(first.orderDate)
                    )
                    .map(order => (
                      <PastListItem
                        pathname={pathname}
                        search={search}
                        key={order.uid}
                        order={order}
                        handleOpenOrderSection={this.handleOpenOrderSection}
                        handleRateOrder={this.handleRateOrder}
                        handleReOrder={this.handleReOrder}
                      />
                    ))}
                </div>
              </div>
            )) || <noscript />}
          </div>
        </div>
      );
    } else {
      return (
        <React.Fragment>
          {/* Header */}
          <div className="head-general with-back visible-xs">
            <a
              href="javascript: void(0)"
              className="back"
              onClick={() => window.history.back()}
            >
              <img src="/png/chevron-left.png" />
            </a>
            <h4>Your Orders</h4>
            <a href="javascript: void(0)" className="close" />
          </div>
          {/* Header */}

          <OrdersNotFound restaurantsLink={restaurantsLink} />
        </React.Fragment>
      );
    }
  }
}

export default withRouter(List);
